import React from 'react';
import TextField from '@material-ui/core/TextField';
import ArrowDownSvg from '../../assets/images/svg/svgArrowDown';

function EmailField(props) {
  return (
    <TextField
      className={props.hasText ? props.classNameText : props.className}
      error={Boolean(props.error)}
      variant="outlined"
      disabled={props.disabled || false}
      id={props.name}
      type="text"
      name={props.name}
      label={props.label}
      autoComplete="email"
      onChange={props.handleChange}
      helperText={props.error}
      defaultValue={props.defaultValue || ''}
    />
  );
}

function SimpleTextField(props) {
  return (
    <TextField
      className={props.hasText ? props.classNameText : props.className}
      error={Boolean(props.error)}
      variant="outlined"
      id={props.name}
      type="text"
      disabled={props.disabled || false}
      name={props.name}
      defaultValue={props.defaultValue || ''}
      label={props.label}
      onChange={props.handleChange}
      helperText={props.error}
      inputRef={props.inputRef}
    />
  );
}

function TextAreaField(props) {
  return (
    <TextField
      className={props.hasText ? props.classNameText : props.className}
      error={Boolean(props.error)}
      variant="outlined"
      id={props.name}
      type="text"
      disabled={props.disabled || false}
      name={props.name}
      defaultValue={props.defaultValue || ''}
      label={props.label}
      onChange={props.handleChange}
      helperText={props.error}
      multiline
      rows={props.rows}
      rowsMax={props.rowsMax}
    />
  )
}

function DropDownField(props) {
  return (
    <TextField
      select
      className={props.hasText ? props.classNameText : props.className}
      value={props.value || ''}
      name={props.name}
      id={props.name}
      variant="outlined"
      error={Boolean(props.error)}
      type="text"
      label={props.label || 'Seleccionar'}
      onChange={props.handleChange}
      disabled={props.disabled || false}
      // defaultValue={props.defaultValue || ''}
      helperText={props.error}
      SelectProps={{
        native: true,
        IconComponent: (props) => <ArrowDownSvg fill={'#000000'}/>,
      }}
      InputLabelProps={{ shrink: !!props.value }}
    >

      {props.data.map((item, i) => (
        <option key={i} value={item.id}>
          {item.name}
        </option>
      ))}
    </TextField>
  );
}

export {
  EmailField,
  TextAreaField,
  SimpleTextField,
  DropDownField,
};